import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import "./DocumentPreview.css";
import { IconButton } from "@mui/material";
import { Add, Remove, Launch } from '@mui/icons-material';
import * as msg from "utils/constants/messages";
import * as c from "utils/constants/constants";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import api from "utils/api/api";
import PDFViewer from "components/PDFViewer/PDFViewer";
import { forceLogout } from "commonFunctions/forceLogout";

const DocumentPreview = (props) => {
    const pdfViewerRef = useRef(null)
    const { 
        data = {}, 
        documentPreviewUrl = "", 
        documentId,
        boundingCoordinates = [], 
        documentSearchString,
        updateDocumentSearchString,
        saveAllData,
        dialogs,
        setDialogs,
        updatePdfViewerData,
        pdfViewerData,
        previousData 
    } = useContext(DocumentDetailContext);
    const [searchResults, setSearchResults] = useState(null);

    useEffect(() => {
        pdfViewerRef.current.updateRotatedPages(data.Entity_Details.rotated_pages);
    }, [data.Entity_Details.rotated_pages]);

    useEffect(() => {
        if(data.Status != c.status.processed && data.Status != c.status.intervention_rqd ) {
            pdfViewerRef.current.setDisableRotate(true);
        } else {
            pdfViewerRef.current.setDisableRotate(false);
        }
    }, [data]);

    useEffect(() => {
        if(!Boolean(documentSearchString)) {
            setSearchResults([]);
        }
    }, [documentSearchString])

    const zoomIn = () => {
        var image = document.getElementById("docImage");
        var currWidth = image.clientWidth;
        image.style.width = currWidth + 40 + "px";
        document.getElementById("img-div").style.overflow = "scroll";
    };
    const zoomOut = () => {
        var image = document.getElementById("docImage");
        var currWidth = image.clientWidth;
        image.style.width = currWidth - 40 + "px";
    };

    const getFaxRemovalStatusMessage = (entityDetails) => {
        console.log(msg);
        console.log("coverpage_completed:", msg.coverpage_completed);
        console.log(typeof msg.coverpage_completed);
        if (entityDetails?.fax_cover_page_drop?.status === "Completed") {
            return msg.coverpage_completed;
        } else if (entityDetails?.fax_cover_page_drop?.status === "In Progress") {
            return msg.coverpage_inprogress;
        } else if (entityDetails?.fax_cover_page_drop?.status === "Failed") {
            return msg.coverpage_failed;
        } else {
            return null;
        }
    }

    const findClick = (e) => {
        e.preventDefault();
    };

    const handleSearch = (value) => {
        updateDocumentSearchString(value);
        if(!value) {
            setSearchResults([]);
            return 0;
        }
        var res = data;
        let isChild = Boolean(res.Entity_Details.parentDocId);
        api.searchStringFromDocument({ search_string: value, is_split_doc: isChild }, documentId)
            .then(res => {
                const { match = [] } = res.data.data;
                let flag = false;
                let finalData = match.map(m => {
                    const [page, string, vertices, dimensions, match] = m || [];
                    const [width, height] = dimensions || [];
                    const [x1, y1, x2, y2] = vertices[0] || [];
                    if (match == "exact") flag = true;
                    return {
                        page,
                        color: "blue",
                        match,
                        vertices: {
                            x1: x1,
                            y1: y1,
                            x2: x2,
                            y2: y2
                        }
                    }
                });
                setSearchResults(finalData.filter(m => flag ? m.match == "exact" : true));
            })
            .catch(error => {
                if (error.response.status === 401) {
                    forceLogout();
                } else window.alert(msg.api_error);
            })
    }

    const handleSearchClose = () => {
        setSearchResults([]);
        updateDocumentSearchString("")
    }

    const handlePdfSave = () => {
        pdfViewerRef.current.setSelectionLayers(false);
        pdfViewerRef.current.updateSelectedPages([]);
        saveAllData("pdf_rotate", false);
    }

    const discardChanges = () => {
        pdfViewerRef.current.setSelectionLayers(false);
        pdfViewerRef.current.updateSelectedPages([]);
        pdfViewerRef.current.updateRotatedPages(previousData.Entity_Details.rotated_pages);
        updatePdfViewerData({
            selectedPages: null,
            rotatedPages: null
        });
    }

    const onSelectionChange = (selectedPages) => {
        updatePdfViewerData(prevState => ({
            ...prevState,
            selectedPages
        }));
    }

    const onRotationChange = (rotatedPages) => {
        updatePdfViewerData(prevState => ({
            ...prevState,
            rotatedPages
        }));
    }

    return <div style={{ width: "50%" }}>
        <div className="title-box-preview">
            <p
                className="sub-title"
                style={{ padding: "10px", textAlign: "left" }}
            >
                Document preview
            </p>
            {data?.Format !== "pdf" && (
                <div className="icon-text">
                    <IconButton onClick={zoomOut} size="large">
                        <Remove className="icon-action-edit" fontSize="small" />
                    </IconButton>
                    <p>Zoom</p>
                    <IconButton onClick={zoomIn} size="large">
                        <Add className="icon-action-edit" fontSize="small" />
                    </IconButton>
                </div>
            )}
            {pdfViewerData.rotatedPages &&  <div className="pdf-button-grp" style={{display: "flex", marginRight: "10px"}}>
                <button
                    className="apply-button"
                    style={{ width: "auto", padding: "0px 22px", marginRight: "10px" }}
                    type="submit"
                    onClick={handlePdfSave}
                >
                    <p className="apply-button-text">Save</p>
                </button>
                <button
                    className="reset-button"
                    style={{ width: "auto", padding: "0px 22px" }}
                    type="submit"
                    onClick={() => {
                        discardChanges();
                    }}
                >
                    <p className="reset-button-text">Cancel</p>
                </button>
            </div>}
        </div>
        {data?.Entity_Details?.fax_cover_page_drop?.hasOwnProperty('status') ?
            <div className={data?.Entity_Details?.fax_cover_page_drop?.status == "Completed" ? "fax_warning_success_msg" : "fax_warning_process_msg"}>
                <div>{getFaxRemovalStatusMessage(data?.Entity_Details)}</div>
            </div> : null}
        {documentPreviewUrl && (
            <PDFViewer
                ref={pdfViewerRef}
                totalPages={data.Page_Count || 0}
                highlightData={boundingCoordinates || []}
                pdfUrl={documentPreviewUrl}
                format={data.Format}
                fileName={data.Name}
                handleSearch={handleSearch}
                onSearchClose={handleSearchClose}
                searchResults={searchResults}
                searchString={documentSearchString}
                showSelection={data.Entity_Details?.is_block_fax ? false : true}
                rotatedPages={data.Entity_Details.rotated_pages || {}}
                onSelectionChange={onSelectionChange}
                onRotationChange={onRotationChange}

            />
        )}
    </div>
}

export default DocumentPreview;
